<template>
  <!-- 头部 -->
  <div class="" style="">
    <!-- 之前大图 -->
    <!-- <div class="topbanner">
      <img class="bigimg" src="/static/image/mHeader/banner.png" alt="" style="width: 100%" />
      <img class="smallimg" src="/static/image/mHeader/banner-small.png" alt="" style="width: 100%" />
    </div> -->

    <!-- 大图banner -->
    <div class="index-banner">
      <!-- setBannerH -->
      <el-carousel ref="bannerRef" trigger="click" :interval="6000" :height="`${bannerH}px`">
        <el-carousel-item v-for="(item, index) of bannerList" :key="index" :name="index + ''">
          <div class="image imgHover">
            <img class="img cursor-pointer" :src="item.titleImg" alt="" :style="`width: 100%;height:${bannerH}px`" />
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>

    <div v-if="isDesktop()">
      <div class="header-bg">
        <div class="wrap flex">
          <img src="/static/image/mHeader/logo.png" alt="" />
          <div class="flex-sub clearfix pt4">
            <div class="fr">
              <img src="/static/image/mHeader/wx_gzh.png" alt="" />
              <div class="fs12 mt4 tac">微信公众号</div>
            </div>
            <div class="fr mr30">
              <img src="/static/image/mHeader/wx_gw.png" alt="" />
              <div class="fs12 mt4 tac">市物协官网</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 导航 -->
      <div class="nav">
        <div class="wrap flex">
          <div
            v-for="(item, index) of navList"
            :key="index"
            @click="navitemClick(item, index)"
            :class="`nav-item flex-sub tac fs18 cursor-pointer ${selectedIndex == index ? 'selected' : ''}`"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="header-bg flex pl10 pr10" style="height: 80px">
        <img src="/static/image/mHeader/logo.png" alt="" style="height: 56px" />
        <i @click="showMobileNav" class="el-icon-s-unfold" style="font-size: 28px; color: #000"></i>
      </div>

      <!-- 移动端导航 -->
      <div :class="`mnavbox ${mobileNavState ? 'active' : ''}`">
        <div class="bg" @click="hideMobileNav"></div>
        <div class="mnav">
          <el-scrollbar style="height: 100vh">
            <el-menu
              unique-opened
              :default-active="$route.path"
              @open="handleOpen"
              @close="handleClose"
              background-color="#333"
              text-color="#fff"
              active-text-color="#4a7cf5"
            >
              <div v-for="(item, index) of mobileNavList" :key="index">
                <el-menu-item v-if="item.name == '首页'" @click="mNavItemClick(`${item.path}`, index)" index="/index">
                  <span slot="title">{{ item.name }}</span>
                </el-menu-item>
                <div v-else>
                  <el-submenu :index="item.path">
                    <template slot="title">
                      <span>{{ item.name }}</span>
                    </template>
                    <el-menu-item-group v-if="item.children && item.children.length > 1">
                      <el-menu-item
                        @click="mNavItemClick(`${item.path}/${item2.path}`, index)"
                        v-for="(item2, index2) of item.children"
                        :key="index2"
                        :index="`${item.path}/${item2.path}`"
                      >
                        <span>{{ item2.name }}</span>
                      </el-menu-item>
                    </el-menu-item-group>

                    <!--  -->
                  </el-submenu>
                </div>
              </div>
            </el-menu>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixinDevice } from '@/util/mixin'
import { mapGetters } from 'vuex'
import router from '@/router'

import { getIndexTopH } from '@/util/index'
// 接口
import {
  findArticleByColIds, // 批量获取列表
} from '@/api/index'

export default {
  mixins: [mixinDevice],
  data() {
    return {
      //       associationProfile
      // associationDynamic
      // partyActivity
      // goodFaithArbitration
      // trainingInvestigation
      // memberDynamics
      // governmentCommunity
      // encyclopediaOverview
      // bidWinning
      navList: [],
      selectedIndex: 0, // 选中的index

      bannerState: 'big',

      // 顶部轮播图
      bannerH: 0, // banner高度
      bannerList: [],

      // 移动端导航
      mobileNavList: [],
      mobileNavState: false,
      mnavAnimState: false,
    }
  },
  computed: {},
  watch: {
    '$route.path': {
      handler(val) {
        console.log('$route.path', val)
        setTimeout(() => {
          this.setSelectIndex(val)
        }, 110)

        // setTimeout(() => {

        // }, 100)

        this.$nextTick(() => {
          if (window.sessionStorage.indexTopHeight) {
            document.body.scrollTop = document.documentElement.scrollTop = parseFloat(
              window.sessionStorage.indexTopHeight
            )
            this.bannerH = parseFloat(window.sessionStorage.indexTopHeight)
          } else {
            let bannerH = getIndexTopH()
            document.body.scrollTop = document.documentElement.scrollTop = bannerH
            this.bannerH = bannerH
          }
        })
      },
      immediate: true,
    },
  },

  created() {
    let interVal = setInterval(() => {
      console.log('循环获取导航')
      if (window.sessionStorage.indexNavList) {
        clearInterval(interVal)
        this.navList = JSON.parse(window.sessionStorage.indexNavList)
        // console.log('this.navList', this.navList)

        // 移动端导航
        let mRoutes = JSON.parse(JSON.stringify(this.$router.options.routes))
        console.log('mRoutes', mRoutes)
        let mobileNavList = []
        mRoutes[0].name = '首页'
        for (let item of mRoutes) {
          if (item.name && item.path.indexOf('/info/') < 0) {
            item.children = item.children.filter((item2) => {
              return item2.path.indexOf('/info/') < 0
            })
            mobileNavList.push(item)
          }
        }

        console.log('mobileNavList', mobileNavList)
        this.mobileNavList = mobileNavList
      }
    }, 100)

    // 获取banner 图片
    this.getBannerList()
  },
  mounted() {
    // 设置大图 1920 660}
    if (window.sessionStorage.indexTopHeight) {
      this.bannerH = parseFloat(window.sessionStorage.indexTopHeight)
    } else {
      this.bannerH = getIndexTopH()
      // window.sessionStorage.indexTopHeight = this.bannerH
    }
    $(window).resize(() => {
      this.bannerH = getIndexTopH()
      window.sessionStorage.indexTopHeight = this.bannerH
    })
    // 顶部图片
    // if (!this.bannerState) {
    //   this.setBannerHeight()
    // } else {
    //   $('.topbanner').addClass('small')
    // }
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // alert(1111)
      console.log('-------beforeRouteUpdate to', to)
      console.log('from', from)
    })
  },
  methods: {
    // setBannerH() {
    //   let winW = $(window).width()
    //   this.bannerH = (winW / 1920) * 660
    //   window.sessionStorage.indexTopHeight = this.bannerH
    // },
    // 设置顶部动画
    // setBannerHeight() {
    //   let winW = $(window).width()
    //   $('.topbanner').height((winW / 1920) * 660)
    //   setTimeout(() => {
    //     // $('.topbanner')
    //     //   .animate({ height: (winW / 1920) * 298 }, 400)
    //     //   .addClass('small')
    //     $('.topbanner').animate({ height: 0 }, 400).addClass('small')
    //     this.bannerState = 'small'
    //     window.sessionStorage.bannerState = 'small'
    //   }, 5000)
    //   $(window).resize(() => {
    //     if (this.bannerState == 'big') {
    //       $('.topbanner').height((winW / 1920) * 660)
    //     } else {
    //       // $('.topbanner').height((winW / 1920) * 298)
    //       $('.topbanner').height(0)
    //     }
    //   })
    // },
    setRouter(routerRes) {
      let addRoutersArr = []
      let navList = []
      for (let item of routerRes) {
        if (item.children.length == 0) {
          // 导航
          let navObj = {
            label: `${item.title}`,
            linkUrl: `/${item.keyWords}/list`,
          }
          navList.push(navObj)

          // 路由
          let routerObj = {
            path: `/${item.keyWords}`,
            component: Layout,
            redirect: `/${item.keyWords}/list`,
            children: [
              {
                path: 'list',
                name: `${item.title}`,
                meta: {
                  title: `${item.title}`,
                },
                component: () => import('@/views/rightStrList'),
              },
              {
                path: 'info',
                name: `${item.title}详情`,
                meta: {
                  title: `${item.title}详情`,
                  hidden: true,
                },
                component: () => import('@/views/rightRichText'),
              },
            ],
          }
          addRoutersArr.push(routerObj)
        } else {
          // 导航
          let navObj = {
            label: `${item.title}`,
            linkUrl: `/${item.keyWords}`,
          }
          navList.push(navObj)
          // 路由
          let routerObj1 = {
            path: `/${item.keyWords}`,
            component: Layout,
            meta: {
              title: `${item.title}`,
            },
            name: `${item.title}`,
            redirect: `/${item.keyWords}/${item.children[0].keyWords}/list`,
            children: [],
          }
          for (let itemChildren of item.children) {
            let listObj = {
              path: `${itemChildren.keyWords}/list`,
              name: `${itemChildren.title}`,
              meta: {
                title: `${itemChildren.title}`,
              },
              component: () => import('@/views/rightStrList'),
            }
            let infoObj = {
              path: `${itemChildren.keyWords}/info`,
              name: `${itemChildren.title}详情`,
              meta: {
                title: `${itemChildren.title}详情`,
              },
              component: () => import('@/views/rightRichText'),
            }
            routerObj1.children.push(listObj)
            routerObj1.children.push(infoObj)
          }
          addRoutersArr.push(routerObj1)
        }
      }
      return {
        addRoutersArr,
        navList,
      }
    },
    // 设置index
    setSelectIndex(val) {
      for (let i = 0; i < this.navList.length; i++) {
        if (val.indexOf(this.navList[i].linkUrl) >= 0) {
          this.selectedIndex = i
          break
        }
      }
    },
    // 导航点击
    navitemClick(item, index) {
      this.selectedIndex = index
      this.$router.push({ path: item.linkUrl })
    },

    // 获取banner列表
    // 获取其他
    getBannerList() {
      let sendObj = {
        colIds: 97,
        page: 1,
        limit: 3,
      }
      findArticleByColIds(sendObj).then((res) => {
        if (res.code == 200) {
          this.bannerList = res.data.article97
        }
      })
    },

    // 移动端 打开导航
    showMobileNav() {
      this.mobileNavState = true
    },
    hideMobileNav() {
      this.mobileNavState = false
      // $('.mnavbox .bg').animate({ opacity: 0 }, 200)
      // $('.mnavbox .mnav').animate({ right: '-200px' }, 200)
      // setTimeout(() => {
      //   this.mobileNavState = false
      // }, 200)
    },

    handleOpen(e) {
      console.log('handleOpen', e)
    },
    handleClose(e) {
      console.log('handleClose', e)
    },
    mNavItemClick(path, index) {
      // ${item.path}/${item2.path}
      this.selectedIndex = index
      this.$router.push({ path })
      this.hideMobileNav()
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
// 顶部图片
.topbanner {
  position: relative;
  overflow: hidden;
  .bigimg {
    // position: absolute;
    // z-index: 2;
    // transition: all 0.5s;
    width: 100%;
    // opacity: 1;
    // top: 0;
    // left: 0;
  }
  .smallimg {
    transition: all 0.5s;
    width: 100%;
    opacity: 0;
  }

  &.small {
    .bigimg {
      width: 100%;
      opacity: 0;
    }
    .smallimg {
      opacity: 1;
    }
  }
}

.header-bg {
  width: 100%;
  height: 110px;
  background: url('/static/image/mHeader/top.png') left top no-repeat;
  background-size: 100% 100%;
  .wrap {
    height: inherit;
  }
}
.nav {
  background-color: #4a7cf5;
  width: 100%;
  height: 80px;
  .nav-item {
    line-height: 80px;
    height: 80px;
    color: #fff;
    transition: all 0.3s;
    &.selected {
      background: #3356ab;
    }
    &:hover {
      background: #3356ab;
    }
  }
}

// 移动端
.mnavbox {
  position: fixed;
  width: 100vw;
  height: 100vh;
  top: 0;
  right: -99999px;
  z-index: 1000;
  font-size: 14px;

  /* 滚动条 */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #666;
    border-radius: 3px;
  }

  .bg {
    position: absolute;
    width: 100vw;
    height: 100vh;
    transition: 0.2s all;
    background: #000;
    opacity: 0;
    z-index: 1001;
  }

  .mnav {
    background: #333;
    position: absolute;
    transition: 0.2s all;
    width: 200px;
    height: 100vh;
    top: 0;
    right: -200px;
    z-index: 1002;
    overflow-x: hidden;
  }

  &.active {
    right: 0;
    .bg {
      opacity: 0.2;
    }
    .mnav {
      right: 0;
    }
  }
}
</style>

<style lang="scss">
.mnavbox {
  // 分组
  .el-menu-item-group__title {
    padding: 0 !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mHeader.vue